import { render } from "./notfound.vue?vue&type=template&id=2ccd98b5"
const script = {}

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.17_webpack@5.97.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"packages/client/src/core-components/notfound.vue"]])

export default __exports__